import "core-js/modules/es.array.concat.js";
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "student-resource"
};
import IframeContainer from '@/components/IframeContainer/index.vue';
import { getStore } from '@/util/store';
export default {
  __name: 'StudentResource',
  setup: function setup(__props) {
    var token = getStore({
      name: 'access_token'
    }) || '761627c4-55a8-4799-bce7-55c4b06af54d';
    // https://devweb.zhixuehuijiao.cn/sub-data-view-svc/studentResourcesDashboard?token=ca4d29d5-d4a5-4a44-9641-90b9043f2ed7&pagetype=main
    var url = "".concat(window.location.origin, "/sub-data-view-svc/studentResourcesDashboard?token=").concat(token, "&pagetype=main");
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(IframeContainer, {
        src: url
      })]);
    };
  }
};